var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoluxBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 58,
    viewBox: "0 0 262 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.16 44.7724V0.468384H106.875V44.7724V57.2072V57.3707H149.915V44.7724H122.16Z",
    fill: "#0057FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8399 0H70.675C61.1611 0 53.375 7.10119 53.375 15.7799V42.0548C53.375 50.7335 61.1611 57.8347 70.675 57.8347H79.8399C89.3538 57.8347 97.1399 50.7335 97.1399 42.0548V15.7799C97.1399 7.10119 89.3538 0 79.8399 0ZM81.1965 37.8789C81.1965 40.8573 78.523 43.2965 75.2575 43.2965C71.9919 43.2965 69.3184 40.8573 69.3184 37.8789V19.9646C69.3184 16.9863 71.9919 14.5471 75.2575 14.5471C78.523 14.5471 81.1965 16.9863 81.1965 19.9646V37.8789Z",
    fill: "#0057FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.619 0.508179C184.619 20.053 184.641 20.1105 184.641 20.1768V37.7508C184.641 40.6717 182.02 43.0667 178.817 43.0667C175.613 43.0667 172.988 40.6761 172.988 37.7508V20.1768C172.988 20.1149 173.006 20.053 173.01 0.512598H157.35V41.8515C157.35 50.3668 164.985 57.3354 174.323 57.3354H183.315C192.648 57.3354 200.288 50.3668 200.288 41.8515V0.508179H184.628H184.619Z",
    fill: "#0057FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.11 57.3707L227.893 0.468384H209.912L226.059 27.901L209.912 49.9072L209.859 57.2912H227.84L236.36 45.3955L243.408 57.3707H261.11Z",
    fill: "#0057FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.86 22.6336L237.248 0.468384H261.11L249.86 22.6336Z",
    fill: "#0057FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6186 14.4277V14.4101H36.9465C41.772 14.4101 45.6871 10.4949 45.6871 5.66944V0.468384H16.2704V0.552343C7.14096 1.40519 0 8.84664 0 17.901C0 27.5298 8.06893 35.338 18.0247 35.338C18.2634 35.338 18.4931 35.3203 18.7274 35.3071L18.4445 35.338L26.2616 35.5104C29.0323 36.1113 31.118 38.5064 31.118 41.361V41.6173H31.1357V44.6487H1.32567V57.3751H45.5546V39.3018C45.5546 29.452 37.2249 21.3964 27.0437 21.3964H20.6186V21.3787C18.7053 21.2947 17.1719 19.779 17.1719 17.9054C17.1719 16.0318 18.7008 14.5161 20.6186 14.4321V14.4277Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoluxBlue);
export default __webpack_public_path__ + "static/media/solux_blue.2f2b570517f110cf2aaf95061e5ef793.svg";
export { ForwardRef as ReactComponent };